<template>
    <section class="gantHistogram">
      <HistogramSlider
          ref="histo"
          :width="width"
          :bar-height="height"
          :forceEdges="false"
          :data="sliderData"
          :handleSize="size"
          :fontSize="size"
          :bar-width="6"
          :min="minCap"
          :max="maxCap"
          :barRadius="1"
          :grid="false"
          primaryColor="#ab323b"
          labelColor="#ab323b"
          @finish="update"
          :key="updateKey"
          :lineHeight="4"
          :step="step"
          :prettify="prettify"
      />
    </section>
</template>

<script>
import HistogramSlider from 'vue-histogram-slider';
import 'vue-histogram-slider/dist/histogram-slider.css';

export default {
  name: 'HistogramWrapper',
  components: {
      HistogramSlider
    },
  data() {
      return {
        updateKey:0,
        previousRange: [],
        expoPrettify: (val) => Math.round(Math.pow(Math.E,val))
      }
    },
  props: {
      sliderData:Array,
      value: {
        type: [Array, Object],
        default: () => [],
      },
      width: Number,
      height: {
        type: Number,
        default: 25
      },
      maxCap: Number,
      minCap: Number,
      expo: {
        type: Boolean,
        default: false
      },
      size: {
        type: Number,
        default: 10
      }
    },
  methods: {
      update(val) {
        if (this.expo) {
          this.value[0] = this.expoPrettify(val.from)
          this.value[1] = this.expoPrettify(val.to)
        }
        else {
          this.value[0] = val.from
          this.value[1] = val.to
        }
        // console.log('updated')
        if (this.value != this.previousRange){
          this.previousRange = [this.value[0], this.value[1]]
          this.$emit('input', this.value)

        }

      }
    },
  updated() {
        this.$emit('input', this.value)

      setTimeout(700, this.$refs.histo.update({ from: this.value[0], to: this.value[1] }))

    },
  mounted() {
      this.previousRange = [this.value[0], this.value[1]]
      this.$refs.histo.$el.querySelector("g > rect.overlay").remove()
      this.$refs.histo.update({ from: this.value[0], to: this.value[1] });
    },
  computed: {
      prettify() {
        if (this.expo) {
          return this.expoPrettify
        }
        else {
          return null
        }
      },
      step() {
        return (this.expo ? 0.0001 : 1)
      }
    }
}
</script>

<style scoped>

</style>
